import { render, staticRenderFns } from "./DataItemDiff.vue?vue&type=template&id=5c7bdad0&scoped=true&"
import script from "./DataItemDiff.vue?vue&type=script&lang=ts&"
export * from "./DataItemDiff.vue?vue&type=script&lang=ts&"
import style0 from "./DataItemDiff.vue?vue&type=style&index=0&id=5c7bdad0&scoped=true&lang=scss&"
import style1 from "./DataItemDiff.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7bdad0",
  null
  
)

export default component.exports